import React from 'react';
import headerImg from '../../../assets/img/about-header.jpg';
import './Header.css';

const Header = () => {
    return (
        <div className="about-header">
            <img src={headerImg} alt="about-header-image" />
            
            <div className='header__content'>
                <h1 id='header__title'>About</h1>
            </div>
        </div>
    );
};

export default Header;